import {
  Button,
  Flex,
  InputSearch,
  PaginationPerPageSelect,
  SearchContext,
} from 'dash-ui';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IAmenitiesTopBar } from './AmenitiesTopBar.interfaces';

const AmenitiesTopBar = ({
  setAmenitySaveModal,
  defaultPerPage,
}: IAmenitiesTopBar) => {
  const { t } = useTranslation(['tables', 'common']);
  const { setSearchSlug } = useContext(SearchContext);
  const [search, setSearch] = useState('');

  return (
    <Flex w="100%" px={6} py={4} justifyContent="space-between" flex={1}>
      <Flex flex={1}>
        <InputSearch
          w="100%"
          css={'height: 40px'}
          placeholder={t('tables:amenities.searchAmenities') || ''}
          value={search}
          onClear={() => {
            setSearch('');
            setSearchSlug('');
          }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSearch(event.target.value);
            setSearchSlug(event.target.value);
          }}
        />
      </Flex>
      <Flex>
        <PaginationPerPageSelect
          label={`${t('common:labels.show')} `}
          w={130}
          mx={4}
          options={[
            defaultPerPage,
            defaultPerPage * 2,
            defaultPerPage * 3,
            defaultPerPage * 5,
          ]}
          defaultValue={defaultPerPage}
        />
        <Button
          icon="plus"
          px={5.5}
          onClick={() => setAmenitySaveModal({ mode: 'add' })}
        >
          {t('tables:amenities.addNewAmenity')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default AmenitiesTopBar;
